import ATMTransactionInquiryDetailsFormHandler from '@Modules/admin/archiving/containers/formHandlers/atmTransactionInquiryDetails/ATMTransactionInquiryDetailsFormHandler'
import { useParams } from 'react-router-dom';
import URLConfig from '@Config/urls/url.config';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import React from 'react';
import { FaArrowLeft } from 'react-icons/fa';
import { Link, NavLink, Outlet } from 'react-router-dom';
import { Box } from '@chakra-ui/react';


const ATMTransactionInquiryDetailsPage = () => {
  const {id} = useParams();
  
  const bg = CC.useColorModeValue('gray.400', 'whiteAlpha.700');
  
  return (
    <Box px={'1em'}>
      
      {/* Back to previous page Section */}
      <CC.HStack>
        <Link
          to={
            URLConfig.ADMIN.ARCHIVING.ARCHIVED_TABLES_MENU.ATM_TRANSACTION_INQUIRY
          }
        >
          <CC.Box
            borderRadius={'50%'}
            p={'0.5rem'}
            _hover={{ backgroundColor: `${bg}` }}
          >
            <FaArrowLeft size={'1.5rem'} />
          </CC.Box>
        </Link>

        <CC.Hide below="md">
          <CC.Heading size="lg">Details</CC.Heading>
        </CC.Hide>

        <CC.Show below="md">
          <CC.Heading size="lg">Retour</CC.Heading>
        </CC.Show>
      </CC.HStack>

      <CC.Divider my={'2rem'} />

      <CC.Heading size="md">
        Cash Disbursements (ATM)
      </CC.Heading>
        
      <ATMTransactionInquiryDetailsFormHandler id={id || 0} />

    </Box>
  )
}

export default ATMTransactionInquiryDetailsPage